import React from 'react';
import { ControlLabel } from 'react-bootstrap';

/* eslint-disable */
export const createRenderer = (render) => ({ input, meta, label, ...rest }) => {
  return (
    <div
      className={[
        meta.error && meta.touched ? 'form-error' : '',
        meta.active ? 'form-active' : '',
      ].join(' ')}
    >
      <ControlLabel>
        {label}
      </ControlLabel>

      {render(input, label, rest)}

      {meta.error && meta.touched &&
        <span>
          {meta.error}
        </span>
      }
    </div>
  );
};
/* eslint-enable */

export const returnDropDownValue = (selectedValue) => {
  if (!selectedValue) {
    return null;
  }
  if (selectedValue.name === 'None') {
    return null;
  }

  return selectedValue.id;
};

export const returnLookupResultValue = (selectedValue) => {
  if (!selectedValue) {
    return null;
  }

  return selectedValue.user_id;
};
